/** Supported locales. Czech is the default — it is the shop's home market. */
export const LOCALES = ["cs", "en"] as const;

export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "cs";

export const LOCALE_LABELS: Record<Locale, string> = {
  cs: "Čeština",
  en: "English",
};

/** Locale tags used for `Intl` formatting, which needs a region. */
export const INTL_LOCALE: Record<Locale, string> = {
  cs: "cs-CZ",
  en: "en-GB",
};

/** Narrow an arbitrary string to a supported locale, falling back to the default. */
export function asLocale(value: string | null | undefined): Locale {
  const base = value?.split("-")[0]?.toLowerCase();
  return LOCALES.includes(base as Locale) ? (base as Locale) : DEFAULT_LOCALE;
}
